import {
  Component,
  OnInit,
  Input,
  Output,
  Inject,
  EventEmitter
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { DialogUploadComponent, DialogUploadData } from '../dialog/dialog-upload.component';

import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';

import { base64StringToBlob, blobToBase64String } from 'blob-util';

import {
  AuthenticationService,
  ApprovalTaskItemApiService,
  AnnotationApiService,
  BlobApiService
} from '../../data-services/index';

import {
  IApplication,
  IApprovalTask,
  IApprovalTaskItem,
  IAnnotation,
  IAnnotationInput,
  IHelp,
  IUser,
  AppLoadService,
  IApprovalTaskItemInput
} from '@ebb-v2/ebb-integration';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  IDialogViewData,
  DialogViewComponent
} from '../dialog/dialog-view.component';
import { url } from 'inspector';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { FileHandle } from '../../dragDrop.directive';
import { cloneDeep } from 'lodash';

export class PhotoFile {
  fileId: string;
  file: any;
  fileShow: boolean;
}
export interface PhotoUploadData {
  isImage: boolean;
  useFormName: string;
  attachmentName: string;
  attachmentType: string;
  attachmentCreatedDate: string;
  attachmentUploadDate: string;
  uploadFileName: string;
  uploadFile: Blob;
}
@Component({
  selector: 'ebb-portal-photos',
  templateUrl: './photo-tiles.component.html'
})
export class PhotoTilesComponent implements OnInit {
  @Input('application') application: IApplication;
  @Input('task') task: IApprovalTask;
  @Output() emitFileUploadEvent = new EventEmitter<IApprovalTask>();

  public currentUser: IUser;

  public taskItems: IApprovalTaskItem[] = [];

  public filesToShow: PhotoFile[] = [];
  public waitForFileToUpload = [];
  public data: PhotoUploadData = {} as PhotoUploadData;
  public promptUploadImage: string;
  public imageNotFound :string;
  public fileSelected: any;
  public fileLocalUrl: any;
  public fileError = false;
  public displayFileUrl: any = null;
  public disableFileSave = true;
  public showRotateImage = false;
  public imageOrientation = -1;
  public rotateDegree = 90;

  files: FileHandle[] = [];
  public displayFileName = 'No file selected.';
  constructor(
    private readonly dialogUpload: MatDialog,
    private readonly deviceService: DeviceDetectorService,
    private readonly infoSheet: MatBottomSheet,
    private readonly dialogView: MatDialog,
    private readonly authenticationService: AuthenticationService,
    private readonly apiAppSettings: AppLoadService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly apiblob: BlobApiService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.promptUploadImage = `${
      this.apiAppSettings.readEnvironSettings().uriEbbAssets
    }/images/promptUploadPhoto.png`;
    this.imageNotFound = `${
      this.apiAppSettings.readEnvironSettings().uriEbbAssets
    }/images/imageNotFound.png`;
  }

  readonly imageAcceptedTypes: string[] = ['image/jpeg', 'image/png'];
  public fileMaxSize = 15;
  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.taskItems = this.task.approvalTaskItems;
    this.taskItems.forEach(item => {
      this.eraseCookie(item.id);
    });
    this.loadSubmittedFiles();
  }
  public isValidFileType(file: Blob): boolean {
    let validType: boolean;
    validType = this.imageAcceptedTypes.indexOf(file.type) > -1;
    return validType;
  }

  public checkFileSize(file: Blob): boolean {
    let validSize = false;

    const fileSize: number = parseFloat((file.size / (1024 * 1024)).toFixed(3));

    Math.round(fileSize * 1000) > this.fileMaxSize * 1000
      ? (validSize = false)
      : (validSize = true);

    return validSize;
  }

  public loadSubmittedFiles(): void {
    this.taskItems.forEach((item, index) => {
      //only run for updated images or first load
      if (item.statusCode > 700000000 &&  (this.waitForFileToUpload[index] === undefined || this.waitForFileToUpload[index] === "run complete")) {
        this.getSubmittedFile(item.payload, item.payloadName);
        this.waitForFileToUpload[index] = false;
      } else if (item.statusCode === 700000000) {
        this.waitForFileToUpload[index] = false;
      }
    });
  }

  public getSubmittedFile(itemId: string, payloadName: string): void {
    if (itemId && itemId.length > 0) {
      this.apiblob.getTaskFiles(itemId, payloadName, 1).subscribe(res => {
        this.createImageFromurl(itemId, res);
      });
    }
  }

  // 1: Submitted Read-only; 2: Contractor Read-only; 3: ALL Edit
  public checkUploadAuthorization(item: IApprovalTaskItem): number {
    const retVal = 3;
    if (
      (this.application.stageCode === 700000000 &&
        this.application.eventPreliminaryReview === true) ||
      (this.application.stageCode === 700000001 &&
        this.application.eventApplicationSubmitted === true)
    ) {
      if (
        item.submissionReject > 0 &&
        (this.isHomeowner() ||
          (this.isContractor() &&
            this.application.contractorPermissionsCode === 700000001))
      ) {
        return 3;
      }
      return 1;
    }
    if (
      this.isContractor() &&
      (this.application.contractorPermissionsCode === 700000003 ||
        this.application.contractorPermissionsCode === 700000002)
    ) {
      return 2;
    }
    return retVal;
  }

  public createImageFromurl(itemId: string, fileBlob: Blob) {
    const reader = new FileReader();
    const fileGet: PhotoFile = {
      fileId: itemId,
      file: null,
      fileShow: false
    };

    reader.addEventListener(
      'load',
      () => {
        fileGet.file = reader.result;
        fileGet.fileShow = true;
        this.filesToShow.push(fileGet);
      },
      false
    );

    reader.readAsDataURL(fileBlob);
  }

  public lookupSubmittedPhoto(itemId): PhotoFile {
    const result = this.filesToShow.find(i => i.fileId === itemId);
    if (result) {
      return result;
    } else {
      const notFound: PhotoFile = {
        fileId: itemId,
        file: this.imageNotFound,
        fileShow: true
      };
      return notFound;
    }
  }

  public onUploadPhotoEvent(item: IApprovalTaskItem): void {
    const dialogUploadDataItem: DialogUploadData = {} as DialogUploadData;

    dialogUploadDataItem.isImage = true;
    dialogUploadDataItem.attachmentName = item.name;

    const dialogRef = this.dialogUpload.open(DialogUploadComponent, {
      width: '400px',
      data: dialogUploadDataItem
    });

    dialogRef.afterClosed().subscribe(result => {
      if (item.id && item.id.length > 0) {
        if (result && result.uploadFileName.length > 0) {
          const index = this.taskItems.findIndex(i => i.id === item.id);
          const updatedItem = this.taskItems[index];
          const fileName = result.uploadFileName.replace(/[;,/?:@&=+$]/g, '');
          updatedItem.payloadName = fileName;
          this.waitForFileToUpload[index] = true;
          blobToBase64String(result.uploadFile)
            .then(base64string => {
              const fileString64 = base64string;
              const annotationInput: IAnnotationInput = {
                id: item.payload ? item.payload : null,
                _Objectid_Value: this.taskItems[index].id,
                objectTypeCode: 'cea_approvaltaskitem',
                fileName: fileName,
                fileSize: result.uploadFile.size,
                mimeType: result.uploadFile.type,
                subject: fileName,
                noteText: '',
                documentBody: fileString64
              };

              this.apiAnnotation
                .saveAnnotation(annotationInput)
                .subscribe(data => {
                  const newPayload = data.id;

                  var taskitem = this.taskItems[index];
                  if (taskitem.isRequired === false) {
                    this.UpdateTaskItemtoRequired(
                      taskitem,
                      updatedItem,
                      index,
                      newPayload,
                      fileName
                    );
                  } else {
                    this.GetTaskItem(index, newPayload, fileName);
                  }
                });
            })
            .catch(err => {
              console.warn('Unable to convert file');
            });
        }
      } else {
        console.warn(`ERROR: Unable to upload file without ID`);
      }
    });
  }

  private UpdateTaskItemtoRequired(
    taskitem: IApprovalTaskItem,
    updatedItem: IApprovalTaskItem,
    index: number,
    newPayload: string,
    newPayloadName: string
  ) {
    const modifyItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    modifyItem.id = taskitem.id;

    modifyItem.isRequired = true;
    this.apiApprovalTaskItem
      .saveItem(
        modifyItem,
        this.application.id,
        updatedItem._Ebb_ApprovalTaskId
      )
      .subscribe(data => {
        this.GetTaskItem(index, newPayload, newPayloadName);
      });
  }

  private GetTaskItem(index: number, newPayload: string, newPayloadName: string) {
    this.apiApprovalTaskItem
      .getItem(this.taskItems[index].id)
      .subscribe(data => {

        var datataskitem =cloneDeep(data as IApprovalTaskItem);
        const index = this.task.approvalTaskItems.findIndex(
          i => i.id === datataskitem.id
        );
        datataskitem.payload =newPayload;
        datataskitem.payloadName = newPayloadName;
        datataskitem.statusCode = 700000003;
        this.task.approvalTaskItems[index] =datataskitem;
         if (this.task.statusCode && this.task.statusCode === 700000002) {
          this.task.statusCode = 700000003;
        }
        
        this.waitForFileToUpload[index] = "run complete";
        this.emitFileUploadEvent.emit(this.task);
        this.ngOnInit();
      });
  }

  public onUploadNAPhotoEvent(item: IApprovalTaskItem): void {
    if (item.id && item.id.length > 0) {
      const index = this.taskItems.findIndex(i => i.id === item.id);
      const updatedItem = this.taskItems[index];
      const fileName = 'not-applicable.png';
      let fileSize: any = 8280;
      updatedItem.payloadName = fileName;
      this.waitForFileToUpload[index] = true;

      const base64string =
        'iVBORw0KGgoAAAANSUhEUgAAAmUAAAJYCAYAAAAja5FUAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH5gsPERAL445x5gAAIABJREFUeJzt3Wu0ZVV9pvF3Tm4C0bIkSAgqhkBUGjCIeDeGgRq0QARFUQSB1jbq0KhJBwMoIIhgvEVto1ERxQsoIoogTTSoQbzFS5QQQmyCIiKiXEREKGrN/nB2mc2CqnNba7//NdfzG6PH6JFA1dNN1Tnv2XvuNZMAAADQqVLKov+d3EMHAAAAFolRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEEAqpbgbAKA3KeWfS9rC3THlraU0r3JHAIiHUQagWinlTST9xt3RskspzffdEQDi4e1LADV7ljugZTWDDMC6bDiL3ySlfIakvWfxe/Xodkk7ltJc4w7BnaWUL5b0UHfHEr21lOZod0TFnuEOaLnCHQAppXy4pHe4O3rwxVKaVe4ILN1MRpmkB0jabEa/V182k3SOpIe7Q3AX99Nw/3z9vjugco9wB7R8yR0ASdKrNdyvGevzlJTy5qU0t7hDsDS8fbk4u6WUn+mOADC/lHKW9HvujpbT3AFjl1LeRtIO7o6eJEknuCOwdIyyxTtl8sUeQGxP0dw3qSjWlNJc5I6ATnIH9Oz57gAsHeNi8e4p6RR3BIB5HegOaPmROwCSpP3cAT1bmVLe0x2BpWGULc0hKeU/ckcAWK/HugNavuIOGLuU8v6SNnd3zMCJ7gAsDaNsaZKkz7ojAKzXA9wBLR9zB0CvdQfMyO4p5TGMz+owypZuh5TyS9wRAO4qpfwYSRu4O6YUSee7I8YspbxC0i7ujhnhwP9AMcqW582TJ4YDiOVgd0DLT0ppGnfEyB2vWB/86BsH/geIUbY895D0CXcEgLv4U3dAy9fdAdBB7oAZ48D/ADHKlm+flHK0B1QCY7edO6Dl4+6AMUspP17SfdwdBhz4HxhGWTc+5Q4AMCel/GBJG7s7phRJZ7ojRm6s44QD/wPDKOvG76eUj3FHAJAkHeoOaLmulGaNO2KsUsobSXq0u8OEA/8DwyjrztEp5ZXuCAB6kjug5VvugJE7UrE+iTtrHPgfEEZZdzaU9Bl3BAA92B3QcpY7YORe5A4w48D/gDDKuvW4lPJe7ghgrFLKW0vazN3R8hF3wFillHeStLW7I4CxnqkbHEZZ9z7qDgBG7FB3QMsNpTS3uiNG7GR3QBAc+B8IRln3VqaU3+mOAEbqqe6Alu+6A8YqpZwV73yhCwf+B4JR1o8Xp5Tv744ARmhnd0DLOe6AEXuxpI3cEYFw4H8AGGX9yJLOdUcAY5JSvqekFe6OllPdASP2SndAMBz4HwBGWX92Tik/zx0BjEi0a3RuLqW5wR0xRpN3Kv7Q3REQB/6DY5T1690p5TE/HweYpae7A1r+zR0wYhzwv3sc+A+OUdavzcXH4YFZeZg7oOU8d8CI7esOCIoD/8Exyvr3rMmzcgD0ZHKVzpbujpZT3AFjlFI+QPGeVRcJB/4DY5T1L4kn/QN9e4Y7oOXXpTRXuyNG6mh3QHArU8pPdEfg7jHKZuMPUsp8EgjozwHugJb/cAeMUUp5heI9FiUiDvwHxSibnZM4YAn05pHugJYL3AEj9XrNvTuB9Xs4349iYpTNzsaSPuWOACoV7X5DzpN5PNcdMBBJcwMWwTDKZutJKeXHuSOAmqSUn6xYX8tuL6W53B0xNinlPSStdHcMyCHuANxVpC9kY/FJdwBQmWivjvzAHTBSPOphcTjwHxCjbPbum1I+yR0BVCTaq8//5A4Ym5TyJpIe5e4YIA78B8Mo8/irlPJW7gigEtu6A1o+5A4YoSPF97Ol4MB/MPwh9thA0jnuCGDoUsq7SdrQ3THljlKab7ojRuiF7oCB4sB/MIwyn91TytHu6gOGJtrTya90B4xNSnlnxfv07ZBw4D8QRpnXB1PK/DcAlm4Pd0DLl90BI/RGd8DAceA/EAaB170kvdcdAQzYDu6Alo+6A8Zk8kPtnu6OCnDgPwhGmd9hKeXt3BHA0Ez+3mzi7pjSlNJ8wR0xMi+VtJE7ogIc+A+CUeaXJJ3rjgAG6DB3QMuP3QEj9Ap3QCU48B8EoyyGB6eU+fQQsDh7uQNavuoOGJOU8raSeJehOxz4D4BRFsffTR6ACGBhHuIOaDndHTAyPIS7Wxz4D4BRFsemks5wRwBDkFLeUlKkMzBF0mfcESOzrzugQhz4N2OUxbLv5GGYANYv2vPJflpK07gjxiKl/GzN/SCLbnHg34xRFs/Z7gBgAPZ2B7TwFP/ZOsodUCkO/JsxyuK5X0r5SHcEENwu7oCWM90BY5FSXilpJ3dHxTjwb8Qoi+nYlPIKdwQQUUp5U0kr3R0tH3cHjMiJmntFB/3gwL8RoyymjcShYWBdDnIHtPyilOY2d8SIHOgOGAEO/JswyuL6E35aAe7Wfu6Alm+7A8YipbynpHu7O0aAA/8mjLLYeEQGcFfRPqHMh3Nm53h3wEhw4N+EURbbfVLKb3NHAFGklDeQdF93R8tp7oAxmDxc+5HujhHhwL8Boyy+l6WUt3FHAEHsq1iHvG8qpbnZHTESrxHfs2aJA/8G/AGPL4sLy4G1nuUOaPmeO2BEXuAOGCEO/M8Yo2wYHppS5hNHgPRod0DLZ90BY5BS3lXSVu6OEeLA/4wxyobjfZPzNMCY3c8d0PIBd8BIcPm4Bwf+Z4xRNhybS/qQOwJwSSk/QbG+Zt1SSnOdO6J2KeUsaQ93x4hx4H+GIn2Bw/yek1Le0R0BmBzsDmi51B0wEi/X3AO14cGB/xlilA1LknSOOwIw+RN3QMv/dQeMxMvdAeDA/6wwyoZnu5Tyy9wRgMED3QEt73cH1C6l/EBJf+DuAAf+Z4VRNkxvmlzKDIxCSnlnxXoL6zelNFe6I0bgZHcAJHHgf2YYZcO0saSz3BHADB3mDmj5T3fASOzjDsBvceB/Bhhlw7VXSvkx7ghgRvZ0B7R83h1Qu5TycyUN/R2BGyX9xB3REQ78zwCjbNh4tQxjsYM7oIXnk/XvSHdABz6luv6scOC/Z4yyYdsqpXyCOwLoU0p5W8V6xWR1Kc333RE1SylvIamGx/8co7mzWMUd0pGHp5Tv6Y6oGaNs+I6YfAEDanWoO6DlCnfACLxesS6eX4qrSmmuKqW5VdJ33TEdSZKOd0fUjFE2fBuK+/dQt73cAS1fdAeMQA13/Z4y9X9/o62iexz47xGjrA6PSinzKSXU6n+4A1q47qxHKeUnS1rh7limoqnHeZTSnC7pN76cTq2c/DdCDxhl9fjQ5I44oBop5ZWSIp1hWVNKc7E7onKvcwd04HuTty2nXWAp6QdnmXvCN/F63FvS37sjgI5Fu+/yR+6AmqWUN5G0u7ujA2++m//ZUTOv6A8H/nvCKKvLCyfXkgC1eJo7oOUid0DljtXwvy/dXkpzWvt/WEpziaSfGXr6wIH/ngz9Dz/uLEk61x0BdOiP3QEtp7sDKne4O6ADX1rP/+4jM6voHwf+e8Aoq8+OKeVD3RHAck3eyor0uJdG0vnuiFqllHeTdF93RweOXc//7hjV88wyDvz3gFFWp3ellCNd3gwsRbTHIlxTStO4Iyr2BndAB25a3wdBSmlulnTpDHv6xoH/jjHK6rSpeJsFw7e/O6Dla+6AWk0+Ob6Hu6MDZy/gn3lb7xWzw4H/jjHK6rV/SnlXdwSwDNE+hfcJd0DFXqm5B2EP3Wvm+wdKad4nafUMWmaBA/8dY5TVbSE/tQHhTF45+T13x5Qi6Ux3RMVe5g7owFWlNFct8J+9sNeS2eLAf4cYZXV7QEr5CHcEsASrFOvuw+tKada4I2qUUt5O0rbujg58YBH/7LyvqA0IB/47xCir3/G8548BinbI/1vugIrVcC9kkXTSgv/h0nxD0vX95cwcB/47wiir30aSPu2OABbpMe6AlrPcARVb5Q7owPfv5lql+Xy8lxIPDvx3hFE2DnuklGv4ZBPG4/7ugJaaHvoZRkr5YEn3cHd04C1L+HeO7rzCJ0l6vTuiBoyy8eCTYxiElPJjJG3g7phy/RJeBcHCvNod0IHbS2k+uNh/qZTmF5L+s4cel2j31A4So2w8tkgpv8kdASxAtC/u/+oOqFFKeQtJO7o7OvDlZfy77+yswu/eHPhfPkbZuLwypby1OwKYx5+6A1o+4w6o1IIPxgd33DL+3XdKuqOrkAB4C3OZGGXjkiV91h0BzGM7d0DLot+awoI8yx3QgZtKaS5a6r88ubbrKx32uO3Ggf/lYZSNz8NSyge4I4C7k1J+sKSN3R1Tbi6lucEdUZuU8l6S7uXu6EAXn2w/poNfIwoO/C8To2yc3p9SjnSQGljrUHdAyyXugEq9zh3QkWV/grKU5kuSftlBSxTRzoQOCqNsnO4p6RR3BHA3nuQOaDnPHVCblPKmknZzd3RgMdcqzedTHf06EXDgfxkYZeN18OStIiCSaH8mF3N1DhbmGNXxvafLs4ZHdfhrRcBbmEtUw18MLE0SnypDIJNPBm/m7pjy61Kaq90RFTrcHdCBIunEzn6xuT9nV3b16wXAgf8lYpTNr3EH9GiHlPJL3BHAxGHugJbL3AG1SSnvLmlLd0cHlnKt0nze3fGv58SB/yVilM3v65Jqfpr3WyZnPAC3p7oDWi5wB1ToDe6Ajry1h1/zLZLW9PDrunDgfwkYZfNbI6nmV5M2UV0X42K4dnIHtHCerEOTT3w/wd3RgdWlNKd2/YuW0qyW9M2uf10jDvwvAaNsASZ/AWv+aPzeKeVHuCMwXpPzJyvcHVNuK6W53B1Rmb+UtKE7ogNf6vHXPr7HX9uBtzAXiVG2cHur7vNlZ7sDMGrR3ur4gTugQi91B3RkOdcqrVcpzXmSbunr1zfgwP8iMcoWqJTmh5Le5e7o0dYp5WPdERitfd0BLRe6A2qSUt5e0gPcHR1Y1rVKC1TTVXgc+F8kRtkilNK8TNL17o4eHZVSXumOwCg9zB3Qcqo7oDInuwM6MovHCB05g99jlqK9Ch4ao2zxnu0O6NGGks5xR2BcUsobSfpdd8eUO0ppvuWOqMwqd0BHXtP3b1BKc4Wkmp6Px4H/RWCULVIpzedV91sbj00pR3s0Aer2DHdAy5XugJqklA/V3Ke8h+7Hk2Mss/D+Gf0+s8JbmAvEKFuafSWtdkf06MMpZf5sYFYOcAe0fNkdUJkj3AEd6fJapfmcpLo+WMaB/wXiG+8SlNLcrPre95+2UtI73REYjUe6A1o+7A6oRUp5S8W7z3Qpimb4as/ktoDvzur3mwEO/C8Qo2yJSmnepLrf5nhRSnlbdwRGYWt3wJSmlKbm4wmzdpI7oCOX9HCt0nxq+f+7tTjwvwCMsuXZR3M/QdUoq66PZiOgyQHgSF+HfuwOqEy0t6aX6m2z/g1LaT6huq7448D/AkT6Yjg4pTSXSDrd3dGjnVLK/HSDPh3kDmi52B1Qi5TyKkk1nCNaXUpziun3ru3+Vd7CnAejbPkOlvQrd0SP3j15ZAHQh8e5A1pq/iFr1o51B3TE+cGP2s4uc+B/HoyyZSqlWSPpBe6OHm0mDj6jP5Ge8l7Ec/o6kVLeXNJu7o6O9Hat0nxKaS6VdK3r9+8BB/7nwSjrQCnNGZJqftjkASnlnd0RqEtKeXfFuqD6p6U0NT2GwOlYzX0DHrpfltL8s7nhNPPv3zWOxKwHo6w7qyStcUf0JIlXENC9Q9wBLd9wB1TkUHdARz7tDpD0OtX1gTIO/K8Ho6wjpTTXSnqTu6NH26aU/9Idgars4Q5o+aQ7oAYp5Uco1rVZy9H7tUrzmTwX89/cHR3jLcx1YJR1qJTm1ZJ+5u7o0YmTsyJAF7Z3B7RwyL8btTxf6+oZXqs0nze7AzrGgf91YJR1L9o9fl3aWNLZ7ggMX0p5e8W6D/HnpTQ1X502EynlDSQ93t3RkVPdAWuV0pwq6XZ3R4c48L8OjLKOldJcJOl8d0ePnphSfoI7AoN3qDug5dvugEr8lWJ9eGOpiqQ3uCNaartpggP/d4NR1o/9Jd3mjujRx90BGLw/cwe0RDjQXYOXugM6ckkpzS3uiBb7+baOceD/bjDKejC5I+1V7o4e3Tel/EZ3BAbtIe6AltoeOzBzKeU/knR/d0dHZn6t0nxKab4p6Rfujo7xFmYLo6wnpTTvknS5u6NHr0opb+WOwPCklLeUFOkDIzdOPuGG5TnZHdAR57VK86ntwygc+G9hlPVrlep6vsy0DcSF5Via57sDWr7vDqjEU9wBHXE/LHZ9jnEHdIwD/y2Msh6V0vxAUtSfuLrw8JTy/u4IDM7e7oAWfrhYppTyCxTr07TLcaw7YF1KaX6h+t6B4cD/FEZZ//6XpJvcET36QEqZP0dYjF3cAS0fcAdU4K/cAR2JcK3SfN7uDugYB/6n8M20Z5O79Gr+SeBekt7njsAwpJQ3lbTS3THlllKa69wRQzY5W/ogd0dHPuMOWIC/l3SHO6JjvIU5wSibgVKacyRd7O7o0aGTh4EC83meO6DlUndABaI9z2s5wj92YvKDfvRX8xaLA/8TjLLZ2Vv1/XSzVhLncrAw+7kDWj7nDqjAAe6AjlxdSnOlO2KBOPBfKUbZjJTS3CDpBHdHjx6UUn6ROwLh7eYOaOE82TKklPeR9Dvujo58yB2wUJNzb7WdVa75mM+CMcpmqJTmOElXuzt69LaUci2fwELHJvcibunumPKbAb0yElUtr9gUDe+Vmk+6AzrGgX8xyhz2dQf06B7iCias236ae5siitoeLTBTKeXNJT3M3dGRfwt4rdJ8jnYH9GBow7hzjLIZK6X5lqRPuTt69LSU8u7uCIQU7ezRP7oDBu54xRrZy/F37oDFKqW5RtJ/uTs6NvoD/4wyj2dLutUd0aOaRyeW7tHugJZT3QEDd4g7oCOrNdyHfL/bHdCx0R/4Z5QZlNKslvQSd0ePtkkph/9oOWZuG3fAlNWlNJe4I4YqpfwoSVu4Ozpy0eQxE0P0Zklr3BEdG/WBf0aZSSnNqar7zr3XppRXuCMQQ0p5D8X6evP/3AEDV9OzyY5zByxVKc0aSV93d3Rs1Af+I32RHKNVkob6E9p8NpR0jjsCYRzkDmj5ojtgqCafon28u6MjN5fSfMkdsUzHuwN6MNq3MBllRqU0V0n6P+6OHj1+zD/x4E7+xB3Qcpo7YMCOkLSBO6Ijg//BsZTmfEm/cnd0bLQH/hllZqU0L5d0vbujRx9zByCEB7oDpqwppan52rO+vdgd0KGj3AEdGfy4bBntgX9GWQzPcgf06D4p5be7I+CTUn6opI3cHVN+6A4YqpTygyXdz93RkZ9U9PDgI90BPRjlgX9GWQClNF+QdKG7o0cvTSnf3x0Bm+e7A1q+4g4YsJPdAR0azLVK85mMyx+7Ozp275TyXu6IWWOUxbGv5p6XU6MsLiwfsz3dAS0fdQcMWC3fJIvqu4v4/e6AHtT4IYb1YpQFUUpzs+p8CXqtXVLKz3VHwOKP3AFTGkkXuCOGKKX8Qkkbuzs6cukAr1WazxtU36f5R3fgn1EWSCnNm1TftRnT/mHycXqMREp5W83diRrFNQN+UKjb/3YHdGhw1yrNp5TmNknfdnd0LEk60R0xS4yyePbW3EvrNdpcPIpgbA5zB7R8zR0wRCnlrSXt4O7oyGrV+VafVNeZv7We5w6YJUZZMKU0l6rux0gcmFLe0R2BmYl2BukMd8BAneQO6NBXan21tJTmTNV3r/KoDvwzymI6RPU9DHCtpPqeqYN1izTAi6Sz3BEDtb87oEOvcwf07Hx3QA9Gc+CfURbQ5D6zw90dPdoupfwKdwT6lVJeKSnSId3rJn+3sAgp5adL+h13R0duLqWp+fFDUp0fGBvNgX9GWVClNJ+Q9C/ujh6dnFLe3B2BXkV7PlnNf5/69Fp3QIeqfzRPKc1lkn7q7ujYaA78M8pi21tSrT/Zbyzpk+4I9Gofd0ALf94WafLqxB+7Ozp0tDtgRmr8QNUoDvwzygIrpblW0t+6O3r0Zynlx7kj0Jto38xr/gBNX16nuVcpavCTUpor3BEzcpzq+xT/KA78M8qCK6X5G0nXujt6dKY7AN1LKW8i6T7ujinXl9LU9qm0WTjEHdChGl89uluTB+Ne4u7oQfUH/hllw1DTJ5/atkopj+KswMgc6A5o+a47YGgmr2JHGtbLUTSCb+gtNb7LUv2Bf0bZAJTSXCzpc+6OHv11SnlLdwQ6Fe0HCR7Dsnivdwd0qMZrldarlOY0Sbe5OzpW/YF/RtlwPEP1/QVbawPxTbM2u7sDWj7oDhiSlPJGkh7r7ujQO9wBJv/kDuhB1Qf+GWUDMTkPU/OzvR6ZUo72aT0sQUo5S/o9d8eUX5bS3OCOGJhXa+6HpRqslvRed4TJUe6AHlR94J9RNiClNO+W9B/ujh6dNvmGjmFbpVif2KvxwHPfXuQO6FC11yrNp5TmO5J+7u7oQbXnA/kGODw1X1i+QtJ73BFYtue4A1pqPo/ZucndtNu4OzpU+7VK8zndHdCDag/8M8oGppTmB5Le7+7o0f9MKT/QHYFleYw7oKXmvy99ONkd0KExXKs0n5puZFir2gP/jLJhepGkm9wRPUmSznNHYFnu5w6Y8utSmmvcEQPzZHdAh6q/Vmk+k/OUl7k7elDlgX9G2QBNzkcc5O7o0UNSyi9wR2DxJs+2inRAvMZvRr1JKf+55q5Aq8VYrlWaz9+5A3pQ5YF/RtlAldKcK+lid0eP3j75WD6GJdpPrxe4AwbmVe6ADl0zomuV5vMPmvsUam2qO/C/oTsAy7K3pJ+pzv+Om0o6Q/EeQor1e4I7oOUD7oChSClvI2kHd0eHLk0pH+yOCOSHkrZ3R3Rst5TyPUtpbnaHdKXGb+ajUUpzQ0r5OFX408LEfinlXScf68YwbOcOmHJbKc3l7ogBOckd0LE9J/8H9Vp74P9l7pCu8PblwJXSnCDpx+6OHn3aHYCFmTxKIdJ5pB+4AwZmP3cAsATRjkwsC6OsDk9zB/To/inlv3FHYEEOdQe01HjFTC9SyvtL2tzdASxBVQf+GWUVmLy9d5a7o0fHpZRXuCMwrye6A1o4T7ZwNT7LCuNRzREeRlk9DpR0qzuiJxtJOtsdgXk9yB0w5Q7OIi7M5AeeXdwdwDJU84R/RlklSmlWq6776tr+NKUc7ZUYTEw+ubeZu2PKf7kDBuR4xbqrFFisap7wzyirSCnNaZK+7+7oUY13uNXi+e6Ali+7Awak5gdRYzyqOPDPKKvPKkmNO6InW6SU3+qOwN16qjug5SPugCFIKT9e0n3cHUAHqjjwzyirTCnNVZLe4e7o0csnb5Uhlp3cAVMaLqFesCre8gEmBn/gn1FWoVKaV0j6hbujJ1nSOe4I/LfJAdtIn469yh0wBJNrzB7t7gA6NPgD/4yyej3bHdCjXVPKNf+/b2gOcQe0fNUdMBBHKtbl8cByDf7AP6OsUqU0X1DdD898X0qZbygx7OsOaOEDIQtT86e1MV6DPvDPKKvb0yWtdkf05HckneqOgCRpV3fAlCLe3p5XSnknSVu7O4AeDPrAP6OsYqU0N0s6wt3Ro4NSyg92R4zZ5FzS77o7pvy0lKbWTx936WR3ANCjwR74Z5RVrpTmrZKucHf0JIlXRdwOcAe0fMMdEF0+GP6mAAARqUlEQVRKOUt6krsD6NFgD/wzysZhH829rVOj7cXbME7PdAe0nOkOGIAXa+7qMqBWgz3wzygbgVKaS1X3wzQ3dAeM2CPcAS1nuAMG4JXuAGAGBnngn1E2HodK+pU7AvWYvA0W6VXKn0/ugMU6pJTvL+kP3R3ADAzywD+jbCRKadZIOszdgao8WbG+hnzbHTAAHPDHmAzuwH+kL6joWSnNmZL+xd2BajzHHdDyKXfAAER7phzQp8Ed+GeUjc/ekta4I1CFx7kDWk5zB0SWUj5A0mbuDmCGBnfgn1E2MqU010r6W3cHqvAAd8CUG0tpbnFHBHe0OwAwGNSBf0bZCJXS/I2ka90dGK6U8iMU61Ov33MHRJZSXiFpZ3cHYDCoA/+MsvHa3x2AQTvYHdDCQ4TX7/WaeysHGKPBHPhnlI1UKc3Fks5zd2Cw9nAHtHzQHRDcc90BgNFgDvwzysbtmZJuc0dgkLZ3B0z5VSnNde6IqFLKe0ha6e4AjAZz4J9RNmKlNLdK+gt3B4Ylpby9pE3cHVMudQcEd4I7AAhgEAf+GWUjV0rzHkmXuTswKIe7A1rOdwdElVLeRNKj3B1AAIM48M8ogyStUr0XlqN7T3IHtJziDgjsSPF1Hlgr/KvG/GWFSmmukPRedwcG4yHugCm3ltL80B0R2AvdAUAgD4t+4J9RhrVeLOlGdwRiSylvKWlzd8eUy90BUaWUd1asC+MBtyTpDe6I9WGUQZJUStNoIAchYRXtUvvPuwMCe6M7AAgo9Pc5Rhl+q5TmXElfcXcgtFXugJZT3QERpZSzpD3dHUBAKyIf+GeUoW0fSXe4IxDWLu6AKbeX0lzijgjqpZI2ckcAQYU98M8ow52U0twg6Th3B+JJKW8u6d7ujilXuAMCe4U7AAgs7IF/RhnuopTmBElXuTsQTrSrer7oDogopbytpO3cHUBgYQ/8M8qwLvu6AxDOfu6AFu67vHsnuQOAAQh54J9RhrtVSvMdSZ90dyCU3dwBU9aU0nzNHREUP1AB8wt54J9RhvV5jqRfuyPgl1LeQNKW7o4pPDD2bqSUny1pU3cHMBDhDvwzyrBOpTSrJf25uwMh7Ke5cxhRXOQOCOoodwAwIOEO/DPKsF6lNKdJ+r67A3YHuANaPuIOiCalvFLSTu4OYEDCHfhnlGEhVklq3BGwerQ7YEpTSnOBOyKgExXr1UxgCEId+N/QHYD4SmmuSim/Q9JfuFtgs407YMpP3AFBHegO6Nh5kvZ3R+C37iXpWtU3/FeklPcqpTnfHSIxyrBApTSvSCk/T9IW7hbMVkp5T8V6Vf2r7oBoJv+NIj3YtwtHl9Lc5o7Ab12XUr5E0s7ukB6cICnEKIv0hRbxRTtXhNmI9tDYT7gDAjreHdCx6yeP5UEsJ7oDehLmwD+jDAtWSnOhpC+4OzBzj3cHTCmSznJHRJJS3kTSI90dHWN4B1RKc7qkW90dPQhz4J9RhsXaV9Lt7gjM1APdAVN+Vkqzxh0RzGtU39fyY9wBWKfPugN6EuLAf21/kdGzUppbJL3a3YHZSCk/VNJG7o4p33IHBPQCd0DH/quU5lp3BNap1q//IZ7wzyjDopXSvFXSFe4OzMSh7oAWrv6aklLeVdJW7o6Ovc8dgHUrpblC0o/cHT2xP+GfUYal2kdz53tQtz3dAS0fcwcEU9vl442kv3VHYF7vcgf0xH7gn1GGJSmluVTSh90d6N0O7oAp15fS1HjIeElSylnSHu6Ojn1ncr0bYnuTpBrPdtoP/DPKsByHSbrZHYF+pJS3lXQPd8eU77oDgnm5Yp3368Kb3AGY3+TDNrXeP2s98M8ow5JN/mIe7u5Abw5zB7R82h0QzMvdAR27bfLIBQzD0e6AnlgP/DPKsCylNGdK+hd3B3ph/yRSywfdAVGklB8o6Q/cHR270B2AhSuluUjS9e6OntgO/DPK0IWnqs7zBWO3oztgyi9LaW5yRwRysjugB691B2DRPuoO6IntwD+jDMtWSnOdpDe6O9CdlPIWkkJcOzJxiTsgmH3cAR27oZTmm+4ILNrRqvNT+LYD/4wydKKU5khJP3V3oDOHuANaznUHRJFSfq6kTd0dHePqrAGavHpd6w9MlgP/jDJ0aT93ADoT7ZWYD7gDAjnSHdADrlUartqelbfWipTyU2f9mzLK0JlSmq+p3nvRxuah7oApvy6lucYdEcHkbeVIZ/268KNSmqvdEViaUpqPSvqNu6Mnr5v1b8goQ9eeqXr/go5CSnkTSfdxd0z5d3dAIK/X3HmXmpziDsCynecO6MnDUsorZvkbMsrQqVKa2yS9wt2BZXmOO6DlAndAIAe6AzrWqN63v8bkCHdAT5LmfhCaGUYZOldK8x5Jl7k7sGT7uwNaeCVFUkr5yZJm+lP7DHxv8oMcBqyU5geSrnJ39GSmB/4ZZejLKtX5Uekx2N0dMOW2yRd8GM63zMBb3AHozLvdAT2Z6YF/Rhl6UUpzhaT3ujuwOJNLrrdyd0z5T3dABJNzfpHGchduL6U5zR2Bzpyseh8iPrMfiBhl6NOLJd3ojsCi7KNYB8m5emfOsarv6/WX3AHozuQu5IvdHT2Z2YH/2v6SI5BSmkbSQe4OLMqz3QEtPJ9szuHugB4c6w5A545yB/RkZgf+GWXoVSnNeZIucndgwR7jDpiyupTmO+4It5TybpLu6+7o2E2lNLW+qjJapTT/LOkGd0dPZnLgn1GGWXiapDvcEViQ+7kDplzpDgjCcgdfz852B6A3p7sDejKTA/+MMvSulOYGcY1KeCnlx0nawN0x5cvuALfJBy/2cHf04DXuAPTmKNX7yfveD/wzyjATpTQnqt7n2NTCcgHvevDJPOmVkjZ0R3Tsx6U0fC2o1OSH8EvdHT3p/cA/owyzFO2Sa9zZE9wBU9aU0vDpPOll7oAenOoOQO9Odgf0pPcD/4wyzEwpzb9K+oS7A+u0nTtgyo/dAW4p5e0kbevu6FiRdKI7Av2aPH+u1juQe31HgVGGWTtI0q/dEbizlPKOkjZ2d0zhk3nSG90BPbiklOZWdwRm4nPugJ70euCfUYaZKqVZLenP3R24i8PcAS0fcwcEsMod0IO3uQMwM3/tDuhRbwf+GWWYuclL299zd+BOnugOmFIkneuOcEopHyzpHu6Ojq0upeFy+ZGY3Flb6zGE3g78M8rg8lRJjTsCv/Ugd8CUn05ugxizV7sDevDP7gDM3HvcAT3p7cA/owwWpTRXS3q7uwNSSnkbSZu6O6Z83R3glFLeQtKO7o4eHOsOwMzVfEl5Lwf+GWWwKaV5paSfuzsQ7jzZ2D+he5I7oAe/nFzBgxGZnCH+qrujJ70c+GeUwe2Z7gDoKe6AlrGPsme5A3rwWXcAbI52B/So8wP/jDJYTR4Q+nl3x8jt5A6Y8vPJT9ejlFLeS9K93B09OModAI/J1/gb3R096fzAP6MMETxd0u3uiDGafEGJNAK+5Q4w6/1uPYOflNJc6Y6AVa2XlCdJb+jyF2SUwa6U5hZJR7g7RirafZdnuwNcUsqbStrN3dGDD7kDYHek6r2k/Lld/mKMMoRQSvM2SVe4O0ZoX3dAy5gvIT9G9X1NLpJOcEfAa3JJ+b+7O3rS6YH/2r4AYNhWqd6fpqLa1R0w5cbJq6Zjdbg7oAeXjvy/Kf5bjdeGrXV8V78QowxhlNJcJunD7o6xSClvJOl33R1TRnvLQ0p5d0lbujt68A53AGIopfmg6r2kfNeuDvwzyhDNYZJudkeMxAHugJZz3AFGnR4WDuIOSe91RyCU890BPenswD+jDKGU0qyRdKi7YySiPSPuA+4Ah5TyBpKe4O7owVe4LgstNX+gq5MD/4wyhFNKc5akb7o7RuCR7oApvyql+YU7wuQvJW3ojuhBZ+dsUIdSmsslXe3u6EknB/4ZZYhqleq9M80upZwlbe3umHKpO8Dope6AHvyqlOYL7giEVOsl5VIHP4gwyhBSKc11qvMOwCj20tw5iCg+5w5wSClvL+kB7o4enOsOQFgnqd4fuJd94J9RhrBKaY6WdI27o1IHugNaRnmeTNLJ7oCe1HzfIZZhco3a19wdPVn2gX9GGaJ7ujugUo91B0y5tZTmh+4Ik1XugB78tJTmB+4IhPYad0CPlnXgn1GG0EppvqFxPyqhL5HeMrvcHeCQUj5U0ibujh7wrEGsVynNhar3kvJlHfhnlGEIDlC9Dx2cuZTyIxTr037/6A4wqfHxAFyrhIU6wx3QoyUf+GeUIbxSmtskvdzdUZFD3AEtoztPllLeUtKD3R09+I9SmpvcERiEo9wBPVrygX9GGQahlOa9ki5zd1RiD3fAlNtLacb4OIxaP1n8TncAhmHyXMJaLylf8oF/RhmG5CniwvIu/KE7YMoV7gCTaFdcdeEOSX/vjsCg1HxJ+ZIO/DPKMBilNFdK+gd3x5BNnosV6XD5he6AWUspr5J0T3dHD77GtUpYjFKaUyXd5u7oCW9fYhReono/tTMLh7sDWj7kDjA41h3Qk9e7AzBItV5SviSpFN4NAsYipfxNSQ93d0zcUUqzkTsCAKLglTJgXB7iDpjyI3cAAETCKANGIqW8laTN3R1TLnIHAEAkjDJgPJ7vDmj5iDsAACJJ7gAAAIDaLOXMPq+UAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACIBRBgAAEACjDAAAIABGGQAAQACMMgAAgAAYZQAAAAEwygAAAAJglAEAAATAKAMAAAiAUQYAABAAowwAACAARhkAAEAAjDIAAIAAGGUAAAABMMoAAAACYJQBAAAEwCgDAAAIgFEGAAAQAKMMAAAgAEYZAABAAIwyAACAABhlAAAAATDKAAAAAmCUAQAABMAoAwAACOD/AwIaARQl+S8WAAAAAElFTkSuQmCC';
      const fileString64 = base64string;
      const annotationInput: IAnnotationInput = {
        id: item.payload ? item.payload : null,
        _Objectid_Value: this.taskItems[index].id,
        objectTypeCode: 'cea_approvaltaskitem',
        fileName: fileName,
        fileSize: fileSize,
        mimeType: 'image/png',
        subject: fileName,
        noteText: '',
        documentBody: fileString64
      };

      this.apiAnnotation.saveAnnotation(annotationInput).subscribe(data => {
        const newPayload = data.id;
        this.apiApprovalTaskItem
          .getItem(this.taskItems[index].id)
          .subscribe(data => {
            const index = this.task.approvalTaskItems.findIndex(
              i => i.id === data.id
            );
            this.task.approvalTaskItems[index] =cloneDeep( data as IApprovalTaskItem);
            this.task.approvalTaskItems[index].payload = newPayload;
            this.task.approvalTaskItems[index].statusCode = 700000003;
            if (this.task.statusCode && this.task.statusCode === 700000002) {
              this.task.statusCode = 700000003;
            }

            this.waitForFileToUpload[index] = "run complete";
            this.emitFileUploadEvent.emit(this.task);
            this.ngOnInit();
          });
      });
    } else {
      console.warn(`ERROR: Unable to upload file without ID`);
    }
  }

  public onViewFileEvent(viewType: number, itemId: string): void {
    const taskItemView: IApprovalTaskItem = this.taskItems.filter(
      i => i.id === itemId
    )[0];

    if (!taskItemView.payload && taskItemView.payload.length === 0) {
      return;
    }

    const dialogViewDataItem: IDialogViewData = {} as IDialogViewData;

    this.apiblob
      .getTaskFiles(taskItemView.payload, taskItemView.payloadName, 1)
      .subscribe(fileBlob => {
        //iOS does not allow open blob file in another tab
        if (this.deviceService.isMobile()) {
          dialogViewDataItem.annotationId = taskItemView.payload;
          dialogViewDataItem.viewType = 2;
          dialogViewDataItem.title = taskItemView.name;
          const dialogRef = this.dialogView.open(DialogViewComponent, {
            maxWidth: '95vw',
            maxHeight: '85vh',
            height: '700px',
            width: '1000px',
            data: dialogViewDataItem
          });
        } else {
          const linkToView = this.document.createElement('a');
          linkToView.href = window.URL.createObjectURL(fileBlob);
          linkToView.target = '_blank';
          linkToView.id = taskItemView.payloadName;
          document.body.appendChild(linkToView);
          linkToView.click();
          linkToView.remove();
        }
      });
  }

  public formatNameToId(name: string): string {
    if (typeof name === 'string') {
      return 'photo-' + name.toLowerCase().replace(/[^a-z0-9\-]/g, '');
    } else {
      return '';
    }
  }

  public lookupIndex(item: IApprovalTaskItem): number {
    return this.task.approvalTaskItems.findIndex(i => i.id === item.id);
  }

  public onClickShowReasonWhy(topic: string): void {
    const item: IHelp = {} as IHelp;
    item.question = 'Reason Why';
    item.answer = topic.replace(/(\r\n|\n|\r)/gm, '<br/>');
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

  /***     User Convenience Methods */
  public isHomeowner(): boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
  public imageCanvasResize(src, maxX, maxY) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        const maxWidth = maxX;
        const maxHeight = maxY;
        let ratio = 1;
        if (img.width < maxWidth && img.height < maxHeight) {
          const ratio = 1;
        } else {
          const ratioX = maxWidth / img.width;
          const ratioY = maxHeight / img.height;
          ratio = ratioX < ratioY ? ratioX : ratioY;
        }
        const finalWidth = img.width * ratio;
        const finalHeight = img.height * ratio;
        elem.width = Math.round(finalWidth);
        elem.height = Math.round(finalHeight);
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, finalWidth, finalHeight);
        const data = ctx.canvas.toDataURL();
        res(data);
      };
         img.onerror = error => {
  const message = error instanceof Error ? error.message : ' failed to load';
  rej(new Error(`load error: ${message}`));
};
    });
  }
  private checkcookie(name) {
    var item = this.getCookie(name);

    if (item === null) {
      return false;
    }
    return true;
  }
  private getCookie(name) {
    name = name + this.currentUser.id;
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  private eraseCookie(name) {
    name = name + this.currentUser.id;
    document.cookie =
      name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  private setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  public dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  public async filesDropped(
    files: FileHandle[],
    item: IApprovalTaskItem
  ): Promise<void> {
    this.files = files;
    this.eraseCookie(item.id);
    if (files.length > 1) {
      this.fileError = true;
      this.displayFileName = `Please upload one Photo`;
      this.setCookie(item.id + this.currentUser.id, this.displayFileName, 1);
      return;
    }
    this.fileSelected = this.files[0].file;
    var fileurl = '';
    await blobToBase64String(this.fileSelected).then(function(base64string) {
      fileurl = 'data:image/jpeg;base64,' + base64string;
    });
    if (this.fileSelected != null) {
      if (item.id && item.id.length > 0) {
        if (this.fileSelected && this.fileSelected.name.length > 0) {
          const index = this.taskItems.findIndex(i => i.id === item.id);
          const updatedItem = this.taskItems[index];
          const fileName = this.fileSelected.name.replace(/[;,/?:@&=+$]/g, '');
          updatedItem.payloadName = fileName;
          this.waitForFileToUpload[index] = true;
          if (!this.isValidFileType(this.fileSelected)) {
            this.fileError = true;
            this.waitForFileToUpload[index] = false;
            this.displayFileName = `Only the following types of files can be uploaded: JPG, PNG.`;
            this.setCookie(
              item.id + this.currentUser.id,
              this.displayFileName,
              1
            );
            return;
          }
          if (!this.checkFileSize(this.fileSelected)) {
            this.fileError = true;
            this.waitForFileToUpload[index] = false;
            this.displayFileName = `The file size must be less than ${
              this.fileMaxSize
            }MB`;
            this.setCookie(
              item.id + this.currentUser.id,
              this.displayFileName,
              1
            );
            return;
          }
          if (fileurl !== '') {
            this.displayFileName = this.fileSelected.name;
            this.data.uploadFileName = this.fileSelected.name;
            const reader = new FileReader();
            
            reader.onload = () => {
              this.fileLocalUrl = fileurl;
              this.imageCanvasResize(this.fileLocalUrl, 1000, 1000).then(
                compressed => {
                  this.displayFileUrl = compressed;
                  this.data.uploadFile = this.dataURItoBlob(
                    this.displayFileUrl.split(',')[1]
                  );
                  this.disableFileSave = false;
                  this.showRotateImage = true;
                  blobToBase64String(this.data.uploadFile).then(
                    base64string => {
                      const fileString64 = base64string;
                      let size: any;
                      size = this.data.uploadFile.size;

                      const annotationInput: IAnnotationInput = {
                        id: item.payload ? item.payload : null,
                        _Objectid_Value: this.taskItems[index].id,
                        objectTypeCode: 'cea_approvaltaskitem',
                        fileName: fileName,
                        fileSize: size,
                        mimeType: this.data.uploadFile.type,
                        subject: fileName,
                        noteText: '',
                        documentBody: fileString64
                      };

                      this.apiAnnotation
                        .saveAnnotation(annotationInput)
                        .subscribe(data => {

                          if((<any>data).error){
                            this.displayFileName = `Error uploading file, please try again`;
                            this.waitForFileToUpload[index] = "run complete";
                          }

                          const newPayload = data.id;
                          var taskitem = this.taskItems[index];
                          if (taskitem.isRequired === false) {
                            this.UpdateTaskItemtoRequired(
                              taskitem,
                              updatedItem,
                              index,
                              newPayload,
                              fileName
                            );
                          } else {
                            this.GetTaskItem(index, newPayload, fileName);
                          }
                        });
                    }
                  );
                }
              );
            };
            reader.readAsDataURL(this.files[0].file);
          }
        }
      }
    }
  }
}
